import { APP_MODE, ROLES, SUBSCRIPTION_PLANS } from '../utils/constant'

const LearnerPaths = [
  '/learning/courses',
  '/learning/courses/:id',
  '/learning/courses/:id/topics/:topicId/pages/:pageId'
]

const DEVELOPER_EXCLUDED_PATHS = [
  // contest paths

  '/contests/create',
  '/contests/:contestId/interview-stage/:stageId/candidate/:candidateId',
  '/contests/:contestId/ppt-stage/:stageId',
  '/contests/:contestId/edit/stage/:stagePreviewId/preview',
  // assessments paths
  '/assessments/:contestId/interview-stage/:stageId/candidate/:candidateId',
  '/assessments/:contestId/ppt-stage/:stageId',
  '/assessments/:contestId/edit/stage/:stagePreviewId/preview',
  // courses paths
  '/courses',
  '/courses/:courseId/edit',
  '/courses/:courseId/topics/:topicId/edit',
  '/courses/:courseId/topics/:topicId/pages/:pageId/edit',
  // candidate details path
  '/candidate-details',
  '/candidate-details/edit:candidateId',
  //settings
  '/resume-pool'
]

export const TENANT_LEVEL_PATHS = ['/settings/profile']

export const routeRoles = {
  '/': {
    modeIncluded: [APP_MODE.HIRING, APP_MODE.LEARNER]
  },

  '/settings/profile': {
    modeIncluded: [APP_MODE.HIRING, APP_MODE.LEARNER]
  },
  '/settings/users': {
    roles: [ROLES.ADMIN],
    redirectPath: '/'
  },
  '/settings/workspaces': {
    roles: [ROLES.ADMIN],
    redirectPath: '/',
    plans: [SUBSCRIPTION_PLANS.ENTERPRISE]
  },
  '/settings/config': {
    roles: [ROLES.ADMIN],
    redirectPath: '/',
    plans: [SUBSCRIPTION_PLANS.ENTERPRISE]
  },
  '/settings/careers-config': {
    roles: [ROLES.ADMIN],
    redirectPath: '/',
    plans: [SUBSCRIPTION_PLANS.ENTERPRISE]
  },
  '/settings/tenant-approvals': {
    roles: [ROLES.ADMIN, ROLES.DEVELOPER],
    redirectPath: '/'
  },
  '/subscription': {
    roles: [ROLES.ADMIN],
    redirectPath: '/'
  },
  '/integrations': {
    roles: [ROLES.ADMIN],
    redirectPath: '/'
  },
  '/databases': {
    redirectPath: '/'
  },
  '/tenant-manager': {
    roles: [ROLES.DEVELOPER],
    redirectPath: '/',
    allowAdmin: false
  },
  '/attempts': {
    roles: [ROLES.DEVELOPER],
    redirectPath: '/',
    allowAdmin: false
  },
  '/tenant-invoices': {
    roles: [ROLES.DEVELOPER],
    redirectPath: '/',
    allowAdmin: false
  },
  '/ai-token-usage': {
    roles: [ROLES.DEVELOPER],
    redirectPath: '/',
    allowAdmin: false
  },
  '/coupons': {
    roles: [ROLES.DEVELOPER],
    redirectPath: '/',
    allowAdmin: false
  },
  '/blacklisted-domain': {
    roles: [ROLES.DEVELOPER],
    redirectPath: '/',
    allowAdmin: false
  },
  '/release-notes': {
    roles: [ROLES.DEVELOPER],
    redirectPath: '/',
    allowAdmin: false
  },
  '/release-notes/create': {
    roles: [ROLES.DEVELOPER],
    redirectPath: '/',
    allowAdmin: false
  },
  '/release-notes/view/:id': {
    roles: [ROLES.DEVELOPER],
    redirectPath: '/',
    allowAdmin: false
  },
  ...DEVELOPER_EXCLUDED_PATHS.reduce((acc, path) => {
    acc[path] = {
      redirectPath: '/',
      rolesExcluded: [ROLES.DEVELOPER]
    }
    return acc
  }, {}),

  // overrdiding job-description path to add plans
  '/job-descriptions': {
    redirectPath: '/',
    rolesExcluded: [ROLES.DEVELOPER]
  },
  '/job-descriptions/:id/edit': {
    redirectPath: '/',
    rolesExcluded: [ROLES.DEVELOPER]
  },

  ...LearnerPaths.reduce((acc, path) => {
    acc[path] = {
      redirectPath: '/',
      modeIncluded: [APP_MODE.LEARNER]
    }
    return acc
  }, {})
}
